import { format } from 'date-fns';
import { Observable } from 'rxjs'
import { EventEmitter } from '@angular/core'
import { cloneDeep } from "lodash";

import { Model, Query, Schema, Result, DateRange, DateRangeValue, DynamicDateRange } from '@hub-components'

export class Layout extends Model {
  x: number
  y: number
  width: number
  height: number

  onChange = new EventEmitter()

  constructor(obj) {
    super(obj)
  }
}

export type DateRangeValueJson = DynamicDateRange | {type: 'fixed', value: string, start_date: string, end_date: string}

export class DashboardWidget extends Model {
  constructor(
    public readonly type: string,
    public layout: Layout,
    public readonly inputs?: any,
    public readonly query?: Query,
    public readonly options?: any,
    public readonly style?: any,
    id?: string,
    schema?: Schema
  ) {
    super()
    this.id = this.id || id || this.generateId()

    this.query = this.query || new Query()

    if (this.options && this.options.dateRange && this.options.dateRange.value) {
      this.options.dateRange.value = this.parseDateRangeValue(this.options.dateRange.value)
    }
  }

  generateId() {
    let s4 = () => {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1)
    }
    return [s4(), s4(), s4(), s4()].join('-')
  }

  asJson() {
    const options = cloneDeep(this.options || {});
    if (options && options.dateRange && options.dateRange.value) {
      options.dateRange.value = this.jsonDateRangeValue(options.dateRange.value)
    }

    return {
      type: this.type,
      layout: this.layout,
      inputs: this.query.asJson(),
      options: options,
      style: this.style,
      query: this.query.asJson()
    }
  }

  private parseDateRangeValue(range: DateRangeValueJson | DateRangeValue): DateRangeValue {
    if (range.type === 'fixed' && 'start_date' in range) {
      const { start_date: rawStartDate, end_date: rawEndDate } = <any> range
      const startDate = new Date(rawStartDate + 'T00:00:00');
      const endDate = new Date(rawEndDate + 'T00:00:00');
      return {
        type: 'fixed',
        startDate: startDate,
        endDate: endDate,
      }
    } else { return <DateRangeValue> range }
  }

  private jsonDateRangeValue(range: DateRangeValue): DateRangeValueJson {
    if (range.type === 'fixed' && 'startDate' in range) {
      const { startDate, endDate } = <DateRange> range
      const startDateStr = format(startDate, 'yyyy-MM-dd');
      const endDateStr = format(endDate, 'yyyy-MM-dd');
      return {
        type: 'fixed',
        value: `${startDateStr.replace(/-/g, '')}-${endDateStr.replace(/-/g, '')}`,
        start_date: startDateStr,
        end_date: endDateStr,
      }
    } else { return <DateRangeValueJson> range }
  }
}
